import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Gate for authenticated routes.
 *
 * This is a UX affordance, not a security boundary -- anyone can edit React
 * state in a debugger. The real check is the backend's, which is why this
 * component intentionally has no permission logic in it: authorization belongs
 * where the data does.
 */
function RequireAuth({ children }) {
  const { authenticated, loading } = useAuth();
  const location = useLocation();

  // Render nothing decisive until the first /me resolves. Redirecting while
  // loading would bounce every already-logged-in user to /login on each refresh.
  if (loading) {
    return <div className="card">Loading…</div>;
  }

  if (!authenticated) {
    // Remember where they were headed so login can send them back.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

export default RequireAuth;
